// extracted by mini-css-extract-plugin
export default {"container":"icon_container__2BQvc","image":"icon_image__3tJoD","label":"icon_label__2dHER","gradient":"icon_gradient__2fbWZ"};